import SocketService from "../common/CompositionAPI/socket";

const host = process.env.VUE_APP_SOCKET;
const payloadSocket = { host, path: "/api/v1/socket" };

const SocketSessions = new SocketService(payloadSocket);

export default SocketSessions;
